export enum Expression {
  equals = '==',
  moreThanEquals = '>=',
  lessThanEquals = '<=',
  moreThan = '>',
  lessThan = '<',
}

export interface SearchQuery {
  field: string
  value: string
  expression: Expression
}

export enum Operator {
  OR = 'OR',
  AND = 'AND',
  EQUAL = '==',
}

interface BuildSearchProps {
  searchParams?: SearchQuery[]
  operator?: Operator
}

export const buildSearch = ({ searchParams, operator }: BuildSearchProps): string | undefined => {
  if (!searchParams || !searchParams.length) return
  if (searchParams.length === 1)
    return `${searchParams[0].field} ${searchParams[0].expression} ${searchParams[0].value}`
  else {
    let searchString = ''
    searchParams.forEach((sP, i) => {
      if (i < searchParams.length - 1) {
        searchString += `(${sP.field} ${sP.expression} ${sP.value}) ${operator} `
      } else {
        searchString += `(${sP.field} ${sP.expression} ${sP.value})`
      }
    })
    return searchString
  }
}
